import { render, staticRenderFns } from "./ExercismAnnotation.vue?vue&type=template&id=778a0b74&"
import script from "./ExercismAnnotation.vue?vue&type=script&lang=js&"
export * from "./ExercismAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports